import {connect} from "react-redux";
import ViewClaim from "./viewClaim";
import {bindActionCreators} from "redux";
import {
  viewClaimDetails,
    modificationRequest
} from "../../../services/redux/maintenance/unclaimedTranx/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
  viewMaterialDetails: state.UnclaimedTranxReducer.getClaimData,
  backToModificationRequest: state.UnclaimedTranxReducer.backToModificationRequest,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      viewClaimDetails,
      modificationRequest,
        documentUploadUrlPublic
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewClaim);
